import { createSlice } from '@reduxjs/toolkit';
import { createDeliveryBuilder, getDashboardDataBuilder, fetchDeliveriesBuilder, fetchDeliveryBuilder } from './builder';

const initialState = {
  dashboardData: {},
  deliveries: {
    data: [],
    maxReached: false,
    page: 1,
    perPage: 0,
    total: 0,
  },
  selectedDelivery: {},

  createDeliveryPending: false,
  fetchDeliveriesPending: false,
  fetchDeliveryPending: false,
  getDashboardDataPending: false,
};

export const deliverySlice = createSlice({
  name: 'deliveryInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    createDeliveryBuilder(builder);
    fetchDeliveriesBuilder(builder);
    fetchDeliveryBuilder(builder);
    getDashboardDataBuilder(builder);
    builder.addCase('logout', () => ({ ...initialState, loggedIn: false }));
  },
});

// export const {} = deliverySlice.actions;

export const selectDashboardData = state => state.deliveryInfo.dashboardData;

export const selectDashboardDataPending = state => state.deliveryInfo.getDashboardDataPending;

export const selectCreateDeliveryPending = state => state.deliveryInfo.createDeliveryPending;
export const selectFetchDeliveryPending = state => state.deliveryInfo.fetchDeliveryPending;
export const selectFetchDeliveriesPending = state => state.deliveryInfo.fetchDeliveriesPending;

export const selectDeliveries = state => state.deliveryInfo.deliveries;
export const selectSelectedDelivery = state => state.deliveryInfo.selectedDelivery;

export default deliverySlice.reducer;
